import * as tslib_1 from "tslib";
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { GlobalFunctionService } from '@providers/global-function/global-function.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var FilesComponent = /** @class */ (function () {
    function FilesComponent(globalDataService, globalFunctionService, requestService, requestV2Service) {
        var _this = this;
        this.globalDataService = globalDataService;
        this.globalFunctionService = globalFunctionService;
        this.requestService = requestService;
        this.requestV2Service = requestV2Service;
        this.fileTypeCategories = {
            doc: 'Documents génériques',
            note: 'Notes',
            plan: 'Plans',
            picture: 'Photos et images',
            invoice: 'Factures',
            planning: 'Planning',
            contract: 'Contrats',
            quote: 'Devis',
            delivery_note: 'Bons de livraisons',
            order_form: 'Bons de commande',
            inbound_delivery_note: 'Bons de livraisons entrée',
            outgoing_delivery_note: 'Bons de livraison sortie'
        };
        this.inited = false;
        this.files = {};
        this.filteredFiles = {};
        this.globalDataService.getCurrentProject().subscribe(function (project) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var projectFilesResult;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!project || this.currentProject) {
                            return [2 /*return*/];
                        }
                        this.currentProject = project;
                        if (!!this.inited) return [3 /*break*/, 2];
                        this.inited = true;
                        return [4 /*yield*/, this.requestV2Service.getProjectFiles(project.id, true)];
                    case 1:
                        projectFilesResult = _a.sent();
                        projectFilesResult.items.forEach(function (file) {
                            var fileCategory = _this.fileTypeCategories[file.type];
                            if (!_this.files[fileCategory]) {
                                _this.files[fileCategory] = [];
                            }
                            _this.files[fileCategory].push(file);
                        });
                        this.filteredFiles = tslib_1.__assign({}, this.files);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
    FilesComponent.prototype.filter = function (text) {
        var _this = this;
        if (!text || text.length <= 0) {
            this.filteredFiles = tslib_1.__assign({}, this.files);
            return;
        }
        this.filteredFiles = {};
        Object.keys(this.files).forEach(function (key) {
            _this.files[key].forEach(function (file) {
                if (file.original_filename.toLowerCase().includes(text.toLowerCase())) {
                    if (!_this.filteredFiles[key]) {
                        _this.filteredFiles[key] = [];
                    }
                    _this.filteredFiles[key].push(text);
                }
            });
        });
    };
    FilesComponent.prototype.isEmpty = function () {
        return (!this.filteredFiles ||
            (Object.entries(this.filteredFiles).length === 0 && this.filteredFiles.constructor === Object));
    };
    FilesComponent.prototype.searchEvent = function (event) {
        this.filter(event.target.value);
    };
    FilesComponent.prototype.download = function (file) {
        var _this = this;
        this.requestV2Service.downloadFile(file.id_file)
            .then(function (data) {
            _this.globalFunctionService.downloadFile(data);
        });
    };
    return FilesComponent;
}());
export { FilesComponent };
